module.exports = __webpack_public_path__ + "media/images/svg/jobs/user-170c800c541e6a7f1623e45433e10575.svg";